import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { MarqueeBanner } from "@/components/site/Marquee";
import { ChapterExperience } from "@/components/site/ChapterExperience";
import { GalleryBento } from "@/components/site/GalleryBento";
import { Amenities } from "@/components/site/Amenities";
import { Reviews } from "@/components/site/Reviews";
import { RockerB } from "@/components/site/RockerB";
import { ContactForm } from "@/components/site/ContactForm";
import { Footer } from "@/components/site/Footer";
import { StickyBookBar } from "@/components/site/StickyBookBar";

export default function LandingPage() {
  useLenis();

  return (
    <div className="relative bg-background antialiased">
      <Navbar />
      <main>
        <Hero />
        <MarqueeBanner />
        <ChapterExperience />
        <GalleryBento />
        <Amenities />
        <Reviews />
        <RockerB />
        <ContactForm />
      </main>
      <Footer />
      <StickyBookBar />
    </div>
  );
}
